'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { submitSubscribesForm, callSubscribesForm } from '../../modules/subcribesForm';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    button_adding: 'Adicionando voluntário, aguarde ...',
    button_include: 'Incluir voluntário na ação',
    button_sending: 'Enviando convite, aguarde ...',
    button_send: 'ENVIAR CONVITE',
    modal_attention: 'Atenção',
    modal_error_email: 'Informe um e-mail válido!',
    select_text: 'Digite o e-mail completo ou matrícula do voluntário que irá adicionar.',
    no_results: 'Nenhum resultado encontrado',
  },
  en: {
    button_adding: 'Adding volunteer, please wait...',
    button_include: 'ADD VOLUNTEER TO THE ACTION',
    button_sending: 'Sending invitation, please wait...',
    button_send: 'SEND INVITATION',
    modal_attention: 'Attention',
    modal_error_email: 'Please enter a valid email!',
    select_text: 'Enter the full email or registration number of the volunteer you are going to add.',
    no_results: 'No Results Found',
  },
  es: {
    button_adding: 'Agregando voluntario, por favor espere...',
    button_include: 'Incluir voluntario en acción',
    button_sending: 'Enviando invitación, por favor espere...',
    button_send: 'ENVIAR INVITACIÓN',
    modal_attention: 'Atención',
    modal_error_email: '¡Por favor ingresa un correo electrónico válido!',
    select_text: 'Ingresa el email completo o número de registro del voluntario que vas a agregar.',
    no_results: 'No se encontraron resultados',
  },
};

// Inscreve o usuário selecionado
const subscription = (challenge_id, user_id) => {
  disableButton(tr[lang].button_adding);

  $.ajax({
    type: 'POST',
    url: '/efetuar-inscricao',
    data: {
      challenge_id,
      user_id,
      _token: $('meta[name="csrf-token"]').attr('content'),
    },
    dataType: 'json',
    success: function (data) {
      if (data.type === 'success') {
        $('#subscribes-table').append(data.html);

        if (data.count) {
          $('.js-counter').html(data.count);
        }

        if (typeof data.free_vacancies !== 'undefined') {
          $('.js-free-vacancies').html(data.free_vacancies);
        }

        $('.js-data-user').val('').trigger('change');
      }

      enableButton(tr[lang].button_include);

      Swal.fire(data.title, data.message, data.type);
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      enableButton(tr[lang].button_include);
    },
  });
};

// Desabilita o botão de inclusão
const disableButton = text => {
  $('.js-include-volunteer').prop('disabled', true);
  $('.js-include-volunteer').text(text);
};

// Habilita o botão de inclusão
const enableButton = text => {
  $('.js-include-volunteer').prop('disabled', false);
  $('.js-include-volunteer').text(text);
};

const show = {
  init() {
    $(document).on('click', '.js-add-presence', function (e) {
      e.preventDefault();

      const challenge_id = $(this).attr('data-challenge');
      const user_id = $(this).attr('data-user');
      const has_form = !!$('[name="has_form"]').length;

      if (has_form) {
        callSubscribesForm(challenge_id, user_id);
      } else {
        subscription(challenge_id, user_id);
      }
    });

    // Envia a função de inscrição do usuário para a função de submit do formulário
    submitSubscribesForm(subscription);

    $(document).on('click', '.js-include-volunteer-external', function (e) {
      e.preventDefault();

      function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      }

      if (isEmail($('.js-data-external').val())) {
        $('.js-include-volunteer-external').prop('disabled', true);
        $('.js-include-volunteer-external').text(tr[lang].button_sending);

        var post = {};

        post.challenge_id = $(this).attr('data-challenge');
        post.email = $('.js-data-external').val();
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = '/convidar-voluntario';

        $.ajax({
          type: 'POST',
          url: url,
          data: post,
          dataType: 'json',
          success: function (data) {
            $('.js-data-external').val('');
            $('.js-include-volunteer-external').prop('disabled', false);
            $('.js-include-volunteer-external').text(tr[lang].button_send);
            $('#invites-table').append(data.html);
            $('.js-subscribes-counter').html(data.counter);
            Swal.fire(data.title, data.message, data.type);
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            $('.js-include-volunteer-external').prop('disabled', false);
            $('.js-include-volunteer-external').text(tr[lang].button_send);
          },
        });
      } else {
        Swal.fire(tr[lang].modal_attention, tr[lang].modal_error_email, 'error');
      }

      return false;
    });

    $(document).on('keyup focus', '.js-form-add-users', function (e) {
      e.preventDefault();

      if ($(this).val().length >= 1) {
        $('.c-search--panel').show();
      } else {
        $('.c-search--panel').hide();
      }

      // Regex para validar email
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Regex para validar número de 6 a 11 dígitos
      const regexNumero = /^\d{6,11}$/;

      // se string for um email ou matrícula
      if (regexEmail.test($(this).val()) || regexNumero.test($(this).val())) {
        $('.c-search--panel-message').hide();

        var post = {};

        post.term = $(this).val();
        post._token = $('meta[name="csrf-token"]').attr('content');
        post.challenge_id = $(this).attr('data-challenge');

        $.ajax({
          type: 'POST',
          url: '/pesquisa-voluntarios/' + post.term + '/challenge',
          data: post,
          dataType: 'json',
          success: function (data) {
            $('#js-results').html(data.html);
          },
        });
      } else {
        $('.c-search--panel-message').show();
        $('#js-results').html('');
      }
    });

    // Esconde a lista de usuários flutuante ao clicar fora da div
    var $panel = $('.c-search--panel');
    $(document).on('click', function (event) {
      let $target = $(event.target);

      if (
        !$panel.is($target) &&
        $panel.has($target).length === 0 &&
        $panel.is(':visible') &&
        !$target.closest('.js-form-add-users').length
      ) {
        $panel.hide();
      }
    });
  },
};

export default show;
